import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { BaleService } from "./bale.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { BaleDateReq, BaleInfoReq, BaleQtyUpdateReq, BaleReportReq, BaleReq, TabNameReq } from "@gtpl/shared-models/raw-material-procurement";

@ApiTags('bale-generation')
@Controller('bale-generation')
export class BaleController {
  constructor(
    private baleService: BaleService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }

    @Post('/getRmInwardInfo')
    async getRmInwardInfo(@Body() req: BaleInfoReq): Promise<CommonResponse> {
      try {
        return await this.baleService.getRmInwardInfo(req);
      } catch (error) {
        console.log(error)
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/createBale')
      async createBale(@Body() req: BaleReq): Promise<CommonResponse> {
        try {
          return await this.baleService.createBale(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getBaleInfo')
      async getBaleInfo(@Body() req: BaleInfoReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleInfo(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getBaleReportInfo')
      async getBaleReportInfo(@Body() req?: BaleInfoReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleReportInfo(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/updateActualBaleQty')
      async updateActualBaleQty(@Body() req: BaleQtyUpdateReq): Promise<CommonResponse> {
        try {
          return await this.baleService.updateActualBaleQty(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getInwardNumberDropDownInfo')
      async getInwardNumberDropDownInfo(@Body() req?:TabNameReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getInwardNumberDropDownInfo(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getVoucherNumberDropDownInfo')
      async getVoucherNumberDropDownInfo(@Body() req:TabNameReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getVoucherNumberDropDownInfo(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAgentDropDownInfo')
      async getAgentDropDownInfo(@Body() req:TabNameReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getAgentDropDownInfo(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getBaleNumberDropDownInfo')
      async getBaleNumberDropDownInfo(): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleNumberDropDownInfo();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

        @Post('/getLotAgainstBaleData')
      async getLotAgainstBaleData(@Body() req?: BaleDateReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getLotAgainstBaleData(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

            @Post('/getLotDataAgainstBaleDate')
      async getLotDataAgainstBaleDate(@Body() req?: BaleDateReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getLotDataAgainstBaleDate(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                @Post('/getBaleReport')
      async getBaleReport(@Body() req?:BaleReportReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleReport(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getBaleNoForBaleReport')
      async getBaleNoForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleNoForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getBaleVariantForBaleReport')
      async getBaleVariantForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleVariantForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getBaleQualityForBaleReport')
      async getBaleQualityForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getBaleQualityForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

     @Post('/getinwardDetailsInBaleReport')
      async getinwardDetailsInBaleReport(@Body() req?:BaleReportReq): Promise<CommonResponse> {
        try {
          return await this.baleService.getinwardDetailsInBaleReport(req);
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getinwardQualityForBaleReport')
      async getinwardQualityForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getinwardQualityForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getInwardVariantForBaleReport')
      async getInwardVariantForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getInwardVariantForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                    @Post('/getInwardVendorForBaleReport')
      async getInwardVendorForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getInwardVendorForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

                        @Post('/getInwardNoForBaleReport')
      async getInwardNoForBaleReport(): Promise<CommonResponse> {
        try {
          return await this.baleService.getInwardNoForBaleReport();
        } catch (error) {
          console.log(error)
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}